// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__L1O+i","tab":"Layout_tab__xIuUt","selectTab":"Layout_selectTab__Mm6yz","tabs":"Layout_tabs__cd03g","content":"Layout_content__HXfeM"};